import React from "react";

import { Icon } from "../../atoms/icon";
import styles from "./index.module.scss";

interface Props {
  speakerName: string;
  companyName: string;
  imageUrl: string | null;
  profile: string;
  isMobile: boolean | null;
}

const MobileSpeakerBlock = ({
  imageUrl,
  speakerName,
  companyName,
  profile,
  isMobile,
}: Props) => (
  <div className={styles.mobileContainer}>
    <div className={styles.mobileImageRow}>
      <div className={styles.imgBackground}>
        {imageUrl ? (
          <img src={imageUrl} className={styles.speakerImg} />
        ) : (
          <div className={styles.defaultSpeakerContainer}>
            <Icon
              name="default_speaker"
              size={isMobile ? "doubleExtraLarge" : "tripleExtraLarge"}
              color="black10"
            />
          </div>
        )}
      </div>

      <div className={styles.mobileNamesContainer}>
        <div className={styles.speakerName}>{speakerName}</div>
        <div className={styles.companyName}>{companyName}</div>
      </div>
    </div>

    <div
      className={styles.profile}
      dangerouslySetInnerHTML={{ __html: profile }}
    ></div>
  </div>
);

const DesktopSpeakerBlock = ({
  imageUrl,
  speakerName,
  companyName,
  profile,
  isMobile,
}: Props) => (
  <div className={styles.desktopContainer}>
    <div className={styles.desktopRow}>
      <div>
        <div className={styles.imgBackground}>
          {imageUrl ? (
            <img src={imageUrl} className={styles.speakerImg} />
          ) : (
            <div className={styles.defaultSpeakerContainer}>
              <Icon
                name="default_speaker"
                size={isMobile ? "doubleExtraLarge" : "tripleExtraLarge"}
                color="black10"
              />
            </div>
          )}
        </div>
      </div>

      <div className={styles.desktopProfilesContainer}>
        <div className={styles.speakerName}>{speakerName}</div>
        <div className={styles.companyName}>{companyName}</div>
        <div
          className={styles.profile}
          dangerouslySetInnerHTML={{ __html: profile }}
        ></div>
      </div>
    </div>
  </div>
);

class SpeakerBlock extends React.PureComponent<Props> {
  public render() {
    const {
      speakerName,
      companyName,
      imageUrl,
      profile,
      isMobile,
    } = this.props;

    return (
      <div className={styles.container}>
        <MobileSpeakerBlock
          speakerName={speakerName}
          companyName={companyName}
          imageUrl={imageUrl}
          profile={profile}
          isMobile={isMobile}
        />
        <DesktopSpeakerBlock
          speakerName={speakerName}
          companyName={companyName}
          imageUrl={imageUrl}
          profile={profile}
          isMobile={isMobile}
        />
      </div>
    );
  }
}

export { SpeakerBlock };
